const MAX_SOURCE_PATH_SEGMENTS = 8;
const MAX_SOURCE_PATH_LENGTH = 220;

export function currentSourceUrl(): string {
  return `${location.origin}${sanitizeSourcePathname(location.pathname || "/")}`;
}

export function sanitizeSourcePathname(value: string): string {
  const pathname = String(value || "/").split(/[?#]/, 1)[0] || "/";
  const segments = pathname
    .split("/")
    .filter(Boolean)
    .slice(0, MAX_SOURCE_PATH_SEGMENTS)
    .map(sanitizeSourcePathSegment)
    .filter(Boolean);
  return `/${segments.join("/")}`.slice(0, MAX_SOURCE_PATH_LENGTH) || "/";
}

function sanitizeSourcePathSegment(value: string): string {
  const decoded = safeDecodeURIComponent(value);
  if (isSensitiveSourcePathSegment(decoded)) return "redacted";
  const safe = decoded.replace(/[^a-zA-Z0-9가-힣._~-]+/g, "-").replace(/-+/g, "-").slice(0, 48);
  return safe || "redacted";
}

function safeDecodeURIComponent(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function isSensitiveSourcePathSegment(value: string): boolean {
  return (
    /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value) ||
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value) ||
    /^(?:app|ws|cnv|ctc|msg|dev_msg|member|client|user|answer|ans|session|token)_[a-z0-9_-]{6,}$/i.test(value) ||
    (value.length >= 16 && /[0-9]/.test(value) && /^[a-z0-9_-]+$/i.test(value))
  );
}
